export default __webpack_public_path__ + "static/media/phoneRinging.d98c6357.svg";